import React from 'react';
import { useLocation } from 'react-router-dom';
import Logo from '../../assets/image 6.svg';

import { Container, Content, } from './styles';

const About = () => {
  const { pathname } = useLocation();
  return (
    <Container nonUserRoute={pathname === "/ocariot-about" ? true : false}>
      <Content>
        <img src={Logo} alt="Ocariot" />
        <div className="body">
          <div className="left-side">
            <p>
              Ocariot UNIFOR é um projeto co-financiado pelo Programa HORIZON 2020
              da União Européia e pelo Ministério da Ciência, Tecnologia e Inovação
              do Brasil através da Rede Nacional de Ensino e Pesquisa (RNP).
            </p>
            <br />
            <p>
              A obesidade infantil é a principal preocupação de saúde pública pediátrica,
              afetando cerca de 224 milhões de crianças, em idade escolar no mundo. Sua
              prevalência triplicou em muitos países europeus desde 1980, aumentando em um ritmo alarmante.
              A obesidade infantil já afeta mais de uma em cada três crianças em idade escolar no Brasil,
              na Grécia e na Espanha. O principal objetivo do OCARIoT UNIFOR é promover a melhoria dos transtornos
              alimentares e físicos e também a prevenção do início da obesidade em crianças (entre 9 e 12 anos).
              Para isso, a OCARIoT desenvolverá uma solução personalizada de coaching baseada na IoT que orienta as
              crianças a adotar comportamentos saudáveis de alimentação e atividade física. A rede de IoT permitirá
              observar os padrões de atividade da vida cotidiana da criança, a evolução da saúde, os parâmetros fisiológicos
              e comportamentais e os dados ambientais.
            </p>
          </div>
          <div className="right-side">
            <p>Participantes do projeto UNIFOR:</p>
            <br />
            <div className="participants">
              <p>Ana Maria Fontenelle Catrib</p>
              <p>Carlos Antonio Bruno da Silva</p>
              <p>Christina César Praça Brasil</p>
              <p>Davi Lopes Teixeira</p>
              <p>Davi Sisnando Studart da Fonseca</p>
              <p>David Rodrigues de Castro Junior</p>
              <p>Dayanna Magalhães dos Reis</p>
              <p>Deborah Baltasar Ribeiro Nogueira</p>
              <p> Diego Hernández Hernández</p>
              <p>Fabiana Neiva Veloso Brasileiro</p>
              <p>Felicia Gabler</p>
              <p>Fernanda Regina Vasconcelos</p>
              <p>Filipe Oliveira de Brito</p>
              <p>Francisco Aglalberto Lourenço da Silva Filho</p>
              <p>Ilana Nogueira Bezerra</p>
              <p>Isaque Bezerra Soares</p>
              <p>Jéssica Soares de Oliveira</p>
              <p>Jéssica Soares de Oliveira Reis</p>
              <p>João Victor Gurgel Brilhante</p>
              <p>Jone Peterson Sousa da Fonseca</p>
              <p>José Eurico de Vasconcelos Filho</p>
              <p>José Fernando Rodrigues Ferreira Neto</p>
              <p>Lucas Cunha Matos</p>
              <p>Lucas de Moura Carvalho</p>
              <p>Lucas Leoncio Santos</p>
              <p>Matheus Leite Piani Mafra</p>
              <p>Maxsuellen Facundo de Moura</p>
              <p>Naiana Anchieta Mendes Melo</p>
              <p>Paulo César Holanda Diógenes Neto</p>
              <p>Pedro Felipe Araújo Cavalcante de Oliveira</p>
              <p>Pedro Leonardo Landim Torquato</p>
              <p>Raquel de Oliveira Cruz</p>
              <p>Ronaldo Almeida de Freitas Filho</p>
              <p>Roney Charles Monteiro Chaves</p>
              <p>Tauily Claussen D'Escragnolle Taunay</p>
              <p>Thiago Bruno Costa de Oliveira</p>
              <p>Yuri Nekan Soares Fontes</p>
            </div>
          </div>
        </div>
      </Content>
    </Container>
  );
}

export default About;